import { Card } from '../../components/home/card';
import { useTranslation } from 'react-i18next';

const SUPPORT_EMAIL = 'support@unvox.ai';

export function SupportRoute() {
    const { t } = useTranslation();

    return (
        <div className="mx-auto w-full max-w-3xl">
            <Card className="animate-fade-up">
                <header className="space-y-3">
                    <p className="text-xs font-semibold uppercase tracking-[0.35em] text-secondary">{t('route.support.txtEyebrow')}</p>
                    <h1 className="text-3xl font-semibold leading-tight text-foreground md:text-4xl">{t('route.support.txtTitle')}</h1>
                    <p className="text-xs text-secondary">
                        {t('route.support.txtLastUpdatedLabel')}: <span className="font-semibold text-foreground/80">{t('route.support.txtLastUpdatedDate')}</span>
                    </p>
                </header>

                <div className="mt-6 space-y-6 text-sm leading-relaxed text-secondary">
                    <section className="space-y-2">
                        <h2 className="text-base font-semibold tracking-tight text-foreground">{t('route.support.txtSectionEmailTitle')}</h2>
                        <p>
                            {t('route.support.txtSectionEmailBodyPrefix')} <a className="font-semibold text-foreground/80 underline-offset-4 hover:underline" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
                        </p>
                    </section>

                    <section className="space-y-2">
                        <h2 className="text-base font-semibold tracking-tight text-foreground">{t('route.support.txtSectionIncludeJobIdTitle')}</h2>
                        <p>
                            {t('route.support.txtSectionIncludeJobIdBody')}
                        </p>
                    </section>

                    <section className="space-y-2">
                        <h2 className="text-base font-semibold tracking-tight text-foreground">{t('route.support.txtSectionBugReportsTitle')}</h2>
                        <p>
                            {t('route.support.txtSectionBugReportsBody')}
                        </p>
                    </section>
                </div>
            </Card>
        </div>
    );
}
